import CustomDelete from 'components/CustomDelete'
import NewStaticTable from 'components/staticTable/NewStaticTable'
import TooltipWrapper from 'global/tooltip/TooltipWrapper'
import useDeleteArea from 'pages/determain-geographic-areas/hooks/useDeleteArea'
import useDeleteSubZoneArea from 'pages/determain-geographic-areas/hooks/useDeleteSubZoneArea'
import EditZoneFrom from 'pages/determain-geographic-areas/table-actions/EditZoneFrom'
import { useEffect, useState } from 'react'
import { AiOutlineEdit } from 'react-icons/ai'
import { BiTrash } from 'react-icons/bi'
import { CgExtensionRemove } from 'react-icons/cg'
import { TbPolygon, TbPolygonOff } from 'react-icons/tb'
import { useDispatch, useSelector } from 'react-redux'
import {
  activeAddZone,
  fetchGeoList,
  setSelectedZone,
} from 'redux/customGeo/customGeoReducer'
import { ActionDeletedPolygon, ActionSidebar } from 'redux/optime/optime'
import { hasPermission } from 'utils/HasPermission'

interface ZonelistsProps {
  subzonesArea: any
  selectedState: any
  setselectedState: (selectedState: any) => void
  selectEditZoneArea: any
  setselectEditZoneArea: any
  getZoneInfo: any
}

function ZoneLists({
  subzonesArea,
  selectedState,
  setselectedState,
  selectEditZoneArea,
  setselectEditZoneArea,
  getZoneInfo,
}: ZonelistsProps) {
  const [openModal, setOpenModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openDeleteSubZoneModal, setOpenDeleteSubZoneModal] = useState(false)
  const [currentData, setCurrentData] = useState(null)

  const { CurrentHub } = useSelector((state: any) => state.currentHubInfo)
  const { areaType } = useSelector((state: any) => state.customGeo)
  const dispatch = useDispatch()
  const { handleDeleteOperation } = useDeleteArea(
    setOpenDeleteModal,
    getZoneInfo
  )
  const { handleDeleteZoneArea } = useDeleteSubZoneArea(
    setOpenDeleteSubZoneModal,
    getZoneInfo
  )

  useEffect(() => {
    dispatch(setSelectedZone(selectedState[0]))
  }, [selectedState])

  useEffect(() => {
    dispatch(setSelectedZone({}))
    setselectedState([])
  }, [CurrentHub?.id, areaType])

  return (
    <div className=' w-[350px]'>
      <NewStaticTable
        selectAble
        ignoreRedux
        // tbodyWapper="max-w-[20px]"
        HoleClassName={'  '}
        column={samplecol}
        data={subzonesArea.map((item: any, index) => {
          return {
            ...item,
            id: item.id,
            title: (
              <TooltipWrapper textProps={item.name}>{item.name}</TooltipWrapper>
            ),
            type: (
              <TooltipWrapper textProps={item.countryType.text}>
                {item.countryType.text}
              </TooltipWrapper>
            ),

            //   zone: item?.polygone,
            operation: (
              <div className='flex w-full gap-3 justify-center'>
                {!item?.polygone && hasPermission('add_zone_operation') ? (
                  <>
                    {!selectEditZoneArea ||
                    item.id !== selectEditZoneArea?.id ? (
                      <TooltipWrapper textProps={'افزودن محدوده منطقه عملیاتی'}>
                        <button
                          className=' border-none	text-[14px]  w-[20px] h-[20px]'
                          onClick={() => {
                            // setselectEditZoneArea(null)
                            // setselectEditZoneArea(item)
                            // handleAddSubZoneArea(item)
                            dispatch(fetchGeoList(item))
                            dispatch(activeAddZone(true))
                          }}
                        >
                          <TbPolygon className='w-full h-full' />
                        </button>
                      </TooltipWrapper>
                    ) : (
                      <TooltipWrapper textProps={'تغییر محدوده منطقه عملیاتی'}>
                        <button
                          className=' border-none	text-[14px]  w-[20px] h-[20px]'
                          onClick={() => {}}
                        >
                          <TbPolygonOff className='w-full h-full' />
                        </button>
                      </TooltipWrapper>
                    )}
                  </>
                ) : (
                  <span className='w-[20px] h-[20px] text-[14px]'></span>
                )}
                {hasPermission('edit_zone_operation') && (
                  <button
                    className=' border-none	text-[14px]  w-[20px] h-[20px]'
                    onClick={() => {
                      setCurrentData(item)
                      setOpenModal(true)
                    }}
                  >
                    <AiOutlineEdit className='w-full h-full' />
                  </button>
                )}
                {hasPermission('delete_zone_operation') && (
                  <button
                    className=' border-none	text-[14px]  w-[20px] h-[20px]'
                    onClick={() => {
                      setOpenDeleteModal(true)
                      setCurrentData(item)
                      dispatch(ActionDeletedPolygon(index))
                    }}
                  >
                    <BiTrash size={20} className='w-full h-full	' />
                  </button>
                )}

                {item?.polygone &&
                hasPermission('delete_zone_operation_poligan') ? (
                  <TooltipWrapper textProps={'حذف منطقه عملیاتی'}>
                    <button
                      className=' border-none	text-[14px]  w-[20px] h-[20px]'
                      onClick={() => {
                        setOpenDeleteSubZoneModal(true)
                        setCurrentData(item)
                      }}
                    >
                      <CgExtensionRemove size={20} className='w-full h-full	' />
                    </button>
                  </TooltipWrapper>
                ) : (
                  <span className='w-[20px] h-[20px] text-[14px]'></span>
                )}
              </div>
            ),
          }
        })}
        selectedState={selectedState}
        setselectedState={setselectedState}
      />
      <EditZoneFrom
        isOpen={openModal}
        setIsOpen={setOpenModal}
        onUpdate={getZoneInfo}
        modalInfo={currentData}
        // polygon={childPolygons.current.at(-1)}
      />
      <CustomDelete
        isModalOpenDelete={openDeleteModal}
        setIsModalOpenDelete={setOpenDeleteModal}
        deleteHandler={() => handleDeleteOperation(currentData)}
        title='حذف محدوده عملیاتی'
      />
      <CustomDelete
        isModalOpenDelete={openDeleteSubZoneModal}
        setIsModalOpenDelete={setOpenDeleteSubZoneModal}
        deleteHandler={() => handleDeleteZoneArea(currentData)}
        title='حذف منطقه محدوده عملیاتی'
      />
    </div>
  )
}

export default ZoneLists

type SamplecolType = {
  header: string
  accessor: string
  id: string
}

const samplecol: Array<SamplecolType> = [
  { header: ' منطقه', accessor: 'title', id: '10' },
  { header: 'نوع', accessor: 'type', id: '11' },
  { header: 'عملیات', accessor: 'operation', id: '12' },
]
